import React, {useState} from 'react';
import axios from "axios";
import {AdminAPIUrl, ShopifyStoreFrontAccessToken, ShopifyStoreLink} from "../../GlobalVar";
import {loginUser} from "../../store/features/UserSlice";
import {Box, Button, Flex, FormControl, FormLabel, Heading, Input, useToast} from "@chakra-ui/react";
import {Link, useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import TailSpinLoader from "../../Comp/ui/loaders/TailSpinLoader";
import aa from 'search-insights';

const LoginComp = ({redirectUrl}) => {
    const [state, setState] = useState({});
    const [error, setError] = useState('');
    const toast = useToast();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const hendleChange = (e) => {
        const {name, value} = e.target;
        setState((prevalue) => {
            return {
                ...prevalue, [name]: value
            }
        })
    }
    const Login = async () => {
        const payload = {
            username: `${state.username}`, password: `${state.password}`
        }
        let response = null;
        try {
            setIsLoading(true);
            response = await axios.post(AdminAPIUrl + '/login', payload);
            if (response.data['message']) {
                setIsLoading(false)
                toast({title: response.data['message'], status: 'error', isClosable: true,});
                setError(response.data['message']);
                return;
            }
        } catch (err) {
            response = err.response;
            if (response.data['message']) {
                setIsLoading(false)
                toast({
                    title: response.data['message'],
                    status: response.data['success'] ? 'success' : 'error',
                    isClosable: true,
                    duration: 10000
                });
                // setError(response.data['message']);
                return;
            }
        }
        const email = response.data['email'];
        const query = `mutation {
         customerAccessTokenCreate(input: {email: "${email}", password:"${state.password}"}) {
           customerAccessToken {
             accessToken
             expiresAt
           }
           customerUserErrors {
             code
             field
             message
           }
           userErrors {
             field
             message
           }
         }
       }`;
        fetch(ShopifyStoreLink, {
            method: "POST", body: query, headers: {
                'Content-Type': 'application/graphql', 'X-Shopify-Storefront-Access-Token': ShopifyStoreFrontAccessToken
            }
        }).then(res => {
            setIsLoading(false);
            const data = res.json()
            Promise.all([data]).then((values) => {
                const customerAccessToken = values[0].data.customerAccessTokenCreate.customerAccessToken;
                if (customerAccessToken) {
                    // localStorage.setItem('customerAccessToken', `${values[0].data.customerAccessTokenCreate.customerAccessToken.accessToken}`);
                    // localStorage.setItem('loginEmail', `${email}`);
                    // toast({title: "Login Success", status: 'success', isClosable: true,});
                    dispatch(loginUser({
                        email, accessToken: customerAccessToken.accessToken, authToken: response.data['access_token'],
                    }));
                    if (redirectUrl) {
                        navigate(redirectUrl);
                    }
                }
                if (values[0].data.customerAccessTokenCreate.customerUserErrors) {
                    const error = values[0].data.customerAccessTokenCreate.customerUserErrors;
                    error.forEach(error => {
                        toast({title: error.message, status: 'error', isClosable: true,});
                        setError(error.message)
                    })
                }
            });
        })
    }

    return (<Box className="form-login">
        <Box>
            <Heading>Sign in to your account</Heading>
            <div className='error-show'>{error}</div>
            <FormControl className="form-mail-lg">
                <FormLabel
                    htmlFor='username' className=''>Username / Email*</FormLabel>
                <Input
                    id='username'
                    type='text'
                    name='username'
                    value={state.username || ""}
                    onChange={hendleChange}/>
            </FormControl>
        </Box>
        <Box>
            <FormControl>
                <FormLabel htmlFor='password' className=''>Password*</FormLabel>
                <Input
                    name='password'
                    value={state.password || ""}
                    onChange={hendleChange}
                    onKeyPress={(e) => e.key === 'Enter' ? Login() : null}
                    id='password'
                    type='password'/>
            </FormControl>
        </Box>
        <Box mt={"10px"}>
            <Flex justifyContent={'center'} alignItems={'center'}>
                <Button onClick={Login} className='form_login_Button orange_button_drillcut'
                        mr={'10px'}>SIGN IN</Button>
                <TailSpinLoader isLoading={isLoading}/>
            </Flex>
        </Box>
        <Box className='form_dt_ft'>
            <Link className='ct_acc' to='/signup'>Create account</Link>
            <br/>
            <Link className='ct_ft_pw' to='/forgot-password'>Forgotten Password</Link>
        </Box>
    </Box>);
};

export default LoginComp;
